/**
Project: Voice Panel (c)
Title: list Users 
Description: Component to dispay the Tenent users page.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import {
  Button,
  Dialog,
  Dropdown,
  ExclamationCircleIcon,
  FilterIcon,
  Flex,
  Popup,
  RetryIcon,
  Table,
  TableRow,
  Text,
  Tooltip,
} from "@fluentui/react-northstar";
import axios from "axios";
import classNames from "classnames";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { Col, Grid, Row } from "react-flexbox-grid";
import { connect } from "react-redux";
import {
  checkIdentitySession,
  manageError,
} from "../../../../core/actions/common-actions";
import { AppPageTitle } from "../../../../core/components/app-page-title";
import IntlUtil from "../../../../core/helpers/intl-util";
import PageUtil from "../../../../core/helpers/page-util";
import ResponseUtil from "../../../../core/helpers/response-util";
import TokenUtil from "../../../../core/helpers/token-util";
import { AppConfigProps } from "../../../../core/settings/app-config";
import { AppURLProps } from "../../../../core/settings/app-urls";
import {
  getTenantAccountsNumberSyncNow,
  hidePageWaitDialog,
  showPageWaitDialog,
} from "../../common/actions/general-actions";
import AlertErrorMessage from "../../common/helpers/alert-error-message";
import AlertInfoMessage from "../../common/helpers/alert-info-message";
import NumbersSyncDialog from "../../common/helpers/numbers-sync-dialog";
import PageLoader from "../../common/helpers/page-loader";
import PageOverlay from "../../common/helpers/page-overlay";
import TableHeaderColumn from "../../common/helpers/table-header-column";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import { VoiceAdminURLProps } from "../../common/settings/voice-admin-urls";
import {
  geSubscriberAccountNumbers,
  getTenentUsers,
  getTenentUsersBulk,
  getUsersRoutingPolicies,
  resetUsersData,
  setUserPhoneNumberToAlter,
  setUserRoutingPolicyToAlter,
  setUsersAllRecords,
  setUsersUpdateRecord,
  tenentUsersUpdateBulk,
  updateUserCheckbox,
  updateUserPhoneNumber,
  updateUserRoutingPolicy,
} from "../actions/user-actions";
import { UsersTenentTableHeaderColumns } from "../settings/users-tenent-header.columns";
import UserFilter from "./user-filter";
import UsersImport from "./user-import";
import UserRow from "./user-row";
import UsersStatus from "./user-status";

class usersTenant extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_vpa_common = "vpa_common";
  _intl_ns_vpa_users = "vpa_users";

  constructor(props) {
    super(props);
    this.usersPageTableRef = React.createRef();
    this.state = {
      isPageDataFetched: false,
      isFilterOpenDialog: false,
      isFormDataFilled: false,
      isFormDataSelected: false,
      isFormDataErrorStatus: false,
      isListDataFetched: false,
      isListLoadMore: false,
      isFormDataChecked: false,
      isAlterDataPropagated: true,
      isShowTooltip: false,
      showPolicyDialog: false,
      numberExtractType: VoiceAdminConstants.USERS.ASSIGN_STATUS.ALL,
      usersBulkStatus: VoiceAdminConstants.USERS.BULK_STATUS,
      searchCriteria: this.searchCriteria(),
      editedNumber: null,
      usersAllRecords: [],
      usersUpdateRecords: [],
      usersNumbersRecords: [],
      totalNumbers: [],
      errorMessage: null,
      showSyncDialog: false,
      syncNumbersInProgress: false,
      isShowSyncNumbersTooltip: false,
    };
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
    await this.loadPageData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.isShowSyncNumbersTooltip !==
        prevState.isShowSyncNumbersTooltip &&
      this.state.isShowSyncNumbersTooltip
    ) {
      setTimeout(async () => {
        await this.setStateAsync({ isShowSyncNumbersTooltip: false });
      }, 5000);
    }
  }

  async componentWillUnmount() {
    this.props.resetUsersData();
    this.props.hidePageWaitDialog();
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  loadPageData = async () => {
    await this.setStateAsync({ isPageDataFetched: false });
    await this.props.hidePageWaitDialog();
    await this.resetUserDataToAlter();
    if (
      this.props.usersRoutingPolicies &&
      this.props.usersRoutingPolicies.length === 0
    ) {
      await this.getUsersRoutingPolicies();
    }
    let queryData = {};
    if (this.props.history.location.state) {
      queryData = {
        name: this.props.history.location.state?.name
          ? this.props.history.location.state?.name
          : "",
        email: this.props.history.location.state?.email
          ? this.props.history.location.state?.email
          : "",
        phone: this.props.history.location.state?.phone
          ? this.props.history.location.state?.phone
          : "",
        policyId: this.props.history.location.state?.policyId
          ? this.props.history.location.state?.policyId
          : "",
          usageLocation: this.props.history.location.state?.usageLocation
          ? this.props.history.location.state?.usageLocation
          : "",
          numberAssignmentStatus: this.props.history.location.state?.numberAssignmentStatus
          ? this.props.history.location.state?.numberAssignmentStatus
          : "",
        filterType: this.props.history.location.state?.filterType
          ? this.props.history.location.state?.filterType
          : "",
        pageSize: this.props.history.location.state?.pageSize
          ? this.props.history.location.state?.pageSize
          : "",
        nextLink: "",
      };
    } else {
      queryData = {
        name: "",
        email: "",
        phone: "",
        policyId: "",
        usageLocation:"",
        numberAssignmentStatus:"",
        filterType: "",
        pageSize: VoiceAdminConstants.USERS.PAGE_SIZE,
        nextLink: "",
      };
    }
    await this.fetchTenentUsers(queryData);
    await this.setStateAsync({
      isShowSyncNumbersTooltip: this.state.isAlterDataPropagated,
    });
    await this.setStateAsync({ isPageDataFetched: true });
  };

  searchCriteria = () => {
    return {
      name: "",
      email: "",
      phone: "",
      policyId: "",
      filterType: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
      pageSize: VoiceAdminConstants.USERS.PAGE_SIZE,
      nextLink: "",
    };
  };

  cleanLocationState = async () => {
    await this.props.history.replace({
      ...this.props.location,
      state: null,
    });
  };

  handleFilterOpenDialog = async () => {
    await this.setStateAsync({ isFilterOpenDialog: true });
  };

  handleFilterCloseDialog = async () => {
    await this.setStateAsync({ isFilterOpenDialog: false });
  };

  getUsersRoutingPolicies = async () => {
    try {
      await this.props.getUsersRoutingPolicies();
    } catch (err) {
      await manageError(err, this.props.history);
    }
  };

  resetUserDataToAlter = async () => {
    await this.props.setUserPhoneNumberToAlter("");
    await this.props.setUserRoutingPolicyToAlter("");
  };

  getListOfPolicy = (policys) => {
    let sortedPolicies = [];

    if (policys && policys.length > 0) {
      policys = [""].concat(policys);
      sortedPolicies = _.orderBy(
        policys,
        (policy) => policy.toLowerCase(),
        "asc"
      );
    }

    return sortedPolicies;
  };

  getConditions() {
    return [
      {
        key: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
        label: IntlUtil.getText(
          this._intl_ns_vpa_users,
          "content.anyOneConditions"
        ),
        value: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
      },
      {
        key: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ALL_CONDITIONS,
        label: IntlUtil.getText(
          this._intl_ns_vpa_users,
          "content.allConditions"
        ),
        value: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ALL_CONDITIONS,
      },
    ];
  }

  clearAlert = async () => {
    await this.setStateAsync({
      showAlert: false,
      errorMessage: null,
      errorDetails: null,
    });
  };

  checkUsersData = async () => {
    if (this.state.usersUpdateRecords.length > 0) {
      await this.setStateAsync({ isFormDataSelected: true });
    } else {
      await this.setStateAsync({ isFormDataSelected: false });
    }
  };

  fetchTenentUsers = async (queryData) => {
    await this.handleFilterCloseDialog();
    await this.clearAlert();
    await axios
      .all([
        getTenentUsers(queryData, this._cancelToken),
        getTenentUsersBulk(this.state.usersBulkStatus, this._cancelToken),
        geSubscriberAccountNumbers(
          this.state.numberExtractType,
          this._cancelToken
        ),
        getTenantAccountsNumberSyncNow(this._cancelToken),
      ])
      .then(
        axios.spread(
          async (usersData, propagationData, numbersData, syncResponse) => {
            if (
              usersData &&
              usersData.status === AppConfigProps.httpStatusCode.ok &&
              usersData.data &&
              propagationData &&
              propagationData.status === AppConfigProps.httpStatusCode.ok &&
              propagationData.data &&
              numbersData &&
              numbersData.status === AppConfigProps.httpStatusCode.ok &&
              numbersData.data &&
              syncResponse &&
              syncResponse.status === AppConfigProps.httpStatusCode.ok &&
              syncResponse.data
            ) {
              if (propagationData.data.result) {
                const propagation = propagationData.data.result;
                await this.setStateAsync({ usersPropagation: propagation });
                if (
                  propagation.overallStatus !==
                  VoiceAdminConstants.USN_DATA_PROPAGATION
                    .OVERALL_STATUS_COMPLETED
                ) {
                  await this.setStateAsync({
                    isAlterDataPropagated: false,
                    isCheckPropagatedStatus: true,
                  });
                } else {
                  await this.setStateAsync({
                    isAlterDataPropagated: true,
                  });
                }
              }
              if (numbersData.data.records) {
                let unassignedNumbers = [];
                numbersData.data.records.forEach((response) => {
                  if (
                    response &&
                    (response.assignStatus === null ||
                      response.assignStatus.toLowerCase() ===
                        VoiceAdminConstants.USERS.ASSIGN_STATUS.UNASSIGNED.toLowerCase())
                  ) {
                    unassignedNumbers.push(response);
                  }
                });
                let phoneNumbers = unassignedNumbers.map((phoneNumber) => {
                  return { ...phoneNumber, allocateStatus: 0 };
                });
                this.setStateAsync({
                  usersNumbersRecords: phoneNumbers,
                  totalNumbers: numbersData.data.records,
                });
              }
              if (usersData.data.records) {
                let filterInfo = usersData.data.info.filter;
                let records = [];
                records = await usersData.data.records.map((rec) => ({
                  ...rec,
                  originalPhone: rec.phone,
                  originalPolicyId: rec?.policyId,
                  isSelected: false,
                  isPhonePopupOpen:false,
                  isPolicyPopupOpen:false
                }));
                await this.props.setUsersAllRecords([...records]);
                await this.setStateAsync({
                  searchCriteria: {
                    ...this.state.searchCriteria,
                    name: filterInfo.name ? filterInfo.name : "",
                    email: filterInfo.email ? filterInfo.email : "",
                    phone: filterInfo.phone ? filterInfo.phone : "",
                    policyId: filterInfo.policyId ? filterInfo.policyId : "",
                    usageLocation:filterInfo?.usageLocation?filterInfo?.usageLocation:"",
                    numberAssignmentStatus:filterInfo?.numberAssignmentStatus?filterInfo?.numberAssignmentStatus:"",
                    filterType: filterInfo.filterType
                      ? filterInfo.filterType
                      : VoiceAdminConstants.USERS.FILTER_CONDITIONS
                          .ANY_CONDITIONS,
                    nextLink: usersData.data.info.nextLink
                      ? usersData.data.info.nextLink
                      : "",
                  },
                  isPageDataFetched: true,
                  isCheckPropagatedStatus: false,
                });
                if (records.length === 0) {
                  await this.setStateAsync({ isShowTooltip: true });
                  setTimeout(
                    async () =>
                      await this.setStateAsync({ isShowTooltip: false }),
                    5000
                  );
                }

                await this.cleanLocationState();
              }
              if (syncResponse.data.result) {
                const syncNumResponse = syncResponse.data.result;
                await this.setStateAsync({
                  syncTenantAccountRecords: syncNumResponse,
                });
                if (
                  syncNumResponse.processStatus.toLowerCase() !==
                  VoiceAdminConstants.USN_DATA_PROPAGATION.OVERALL_STATUS_COMPLETED.toLowerCase()
                ) {
                  await this.setStateAsync({
                    syncNumbersInProgress: true,
                  });
                } else {
                  await this.setStateAsync({
                    syncNumbersInProgress: false,
                  });
                }
              }
            }
          }
        )
      )
      .catch(async (err) => {
        await this.setStateAsync({ isPageDataFetched: true });
        const errorStatus = ResponseUtil.getStatus(err);
        if (
          errorStatus &&
          errorStatus === AppConfigProps.httpStatusCode.badRequest
        ) {
          const primeError = ResponseUtil.getPrimeError(err);
          if (primeError) {
            if (
              primeError.code ===
              VoiceAdminConstants.SERVER_ERROR_CODE.VOICE_SETUP_NOTCOMPLETED
            ) {
              this.props.history.push(VoiceAdminURLProps.setup);
              return;
            } else if (
              primeError.code ===
                VoiceAdminConstants.SERVER_ERROR_CODE
                  .USERS_QUERY_PERAMETER_MISSING_OR_INVALID ||
              primeError.code ===
                VoiceAdminConstants.SERVER_ERROR_CODE.USERS_MICROSOFT_TENANT
            ) {
              await this.setStateAsync({
                errorDetails: primeError.message,
              });
            }
          }
          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_users,
              "notification.error.usersDataRetrievingFailed"
            ),
            showAlert: true,
          });
        } else {
          await manageError(err, this.props.history);
        }
      });
  };

  fetchTenentUsersBulkStatus = async () => {
    getTenentUsersBulk(this.state.usersBulkStatus, this._cancelToken)
      .then(async (res) => {
        if (
          res &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res.data
        ) {
          const propagation = res.data.result;
          await this.setStateAsync({ usersPropagation: propagation });
          if (
            propagation.overallStatus !==
            VoiceAdminConstants.USN_DATA_PROPAGATION.OVERALL_STATUS_COMPLETED
          ) {
            await this.setStateAsync({
              isAlterDataPropagated: false,
              isCheckPropagatedStatus: true,
            });
          } else {
            await this.setStateAsync({ isAlterDataPropagated: true });
          }
        }
      })
      .catch(async (err) => {
        await manageError(err, this.props.history);
      });
  };

  fetchSubscriberNumbers = async () => {
    await geSubscriberAccountNumbers(
      this.state.numberExtractType,
      this._cancelToken
    )
      .then(async (res) => {
        if (res && res.data && res.data.records && res.data.records) {
          let unassignedNumbers = [];
          res.data.records.forEach((response) => {
            if (
              response &&
              (response.assignStatus === null ||
                response.assignStatus.toLowerCase() ===
                  VoiceAdminConstants.USERS.ASSIGN_STATUS.UNASSIGNED.toLowerCase())
            ) {
              unassignedNumbers.push(response);
            }
          });
          let phoneNumbers = unassignedNumbers.map((phoneNumber) => {
            return { ...phoneNumber, allocateStatus: 0 };
          });
          this.setStateAsync({
            usersNumbersRecords: phoneNumbers,
            totalNumbers: res.data.records,
          });
        }
      })
      .catch(async (err) => {
        await this.setStateAsync({ isPageDataFetched: true });
        const errorStatus = ResponseUtil.getStatus(err);
        if (
          errorStatus &&
          errorStatus === AppConfigProps.httpStatusCode.badRequest
        ) {
          const primeError = ResponseUtil.getPrimeError(err);
          if (
            primeError &&
            primeError.code ===
              VoiceAdminConstants.SERVER_ERROR_CODE.VOICE_SETUP_NOTCOMPLETED
          ) {
            this.props.history.push(VoiceAdminURLProps.setup);
            return;
          }
        }
        await manageError(err, this.props.history);
      });
  };

  getUsersPropagationInfoText = (propagation) => {
    if (propagation) {
      let propagationTimestamp = propagation.createTimestamp;
      if (
        propagation.endTimestamp &&
        propagation.endTimestamp !== "0001-01-01T00:00:00"
      ) {
        propagationTimestamp = propagation.endTimestamp;
      }
      const timestampObj = moment(propagationTimestamp);
      const dateString = timestampObj.format("ll");
      const timeString = timestampObj.format("LTS");

      let text = IntlUtil.getText(
        this._intl_ns_vpa_users,
        "notification.info.usersDataPropagationCompleted"
      );
      if (timestampObj && dateString && timeString) {
        text =
          text +
          " " +
          IntlUtil.getSubstituteText(
            this._intl_ns_vpa_users,
            "notification.info.usersDataPropagationDateTime",
            [
              {
                key: "<DATE>",
                value: dateString,
              },
              {
                key: "<TIME>",
                value: timeString,
              },
            ]
          );
      }
      return text;
    } else return "";
  };

  openUsersStatusDialog = async () => {
    await this.setStateAsync({ showUsersStatusDialog: true });
  };

  refreshUserPropagationBulk = async (usersPropagation) => {
    if (
      usersPropagation &&
      usersPropagation.overallStatus !==
        VoiceAdminConstants.USN_DATA_PROPAGATION.OVERALL_STATUS_COMPLETED
    ) {
      await this.setStateAsync({
        isAlterDataPropagated: false,
        isCheckPropagatedStatus: true,
      });
      await this.setUsersUpdateData(usersPropagation?.data);
    } else {
      if (!this.state.isAlterDataPropagated)
        await this.setUsersUpdateData(usersPropagation?.data);
      await this.setStateAsync({
        isAlterDataPropagated: true,
        usersPropagation: usersPropagation,
      });
    }
  };

  renderUsersStatusDialog = () => {
    return (
      <UsersStatus
        showDialogBox={this.state.showUsersStatusDialog}
        history={this.props.history}
        functionSeettings={"listView"}
        refreshUserPropagationBulk={this.refreshUserPropagationBulk}
        hideDialogBox={async () => {
          await this.setState({ showUsersStatusDialog: false });
          if (this.state.numberRemoved) {
            await this.setStateAsync({ numberRemoved: false });
            await this.setStateAsync({ isShowSyncNumbersTooltip: true });
          }
        }}
        isAlterDataPropagated={this.state.isAlterDataPropagated}
        fetchSubscriberNumbers={this.fetchSubscriberNumbers}
      />
    );
  };

  setUsersUpdateData = async (usersPropagationRecords) => {
    if (usersPropagationRecords && usersPropagationRecords.length > 0) {
      let usersAllRecords = this.props.usersAllRecords;
      usersPropagationRecords.forEach(async (record) => {
        if (
          record.processStatus ===
            VoiceAdminConstants.USN_DATA_PROPAGATION
              .ITEM_PROCESS_STATUS_COMPLETED &&
          record.updateStatus ===
            VoiceAdminConstants.USN_DATA_PROPAGATION.ITEM_UPDATE_STATUS_FAILURE
        ) {
          let usersRecord = {};
          if (record && record.paramName === "Policy") {
            let item = usersAllRecords.find((x) => x.id === record.id);
            usersRecord = {
              ...record,
              paramValue: item.originalPolicyId,
            };
          }
          if (record && record.paramName === "Phone") {
            let item = usersAllRecords.find((x) => x.id === record.id);
            usersRecord = {
              ...record,
              paramValue: item.originalPhone,
            };
          }
          await this.props.setUsersUpdateRecord(usersRecord);
        } else if (
          record.processStatus ===
            VoiceAdminConstants.USN_DATA_PROPAGATION
              .ITEM_PROCESS_STATUS_COMPLETED &&
          record.updateStatus ===
            VoiceAdminConstants.USN_DATA_PROPAGATION.ITEM_UPDATE_STATUS_SUCCESS
        ) {
          await this.props.setUsersUpdateRecord(record);
        }
      });

      let numberRemoved =
        usersPropagationRecords.every(
          (rec) => rec?.processStatus === "Completed"
        ) &&
        usersPropagationRecords.some(
          (rec) =>
            rec?.paramName === "Phone" &&
            (rec?.actionType === "Remove" ||
              rec?.actionType === "Update" ||
              rec?.actionType === "Import") &&
            rec?.updateStatus === "Success"
        );
      await this.setStateAsync({ numberRemoved });
    }
  };

  updatePhoneNumber = async (
    id,
    email,
    phoneNumber,
    enterpriseVoiceStatus,
    allocateStatus
  ) => {
    if (
      id !== null &&
      id.length > 0 &&
      phoneNumber &&
      phoneNumber.length > 0 &&
      email &&
      email.length > 0
    ) {
      await this.props.updateUserPhoneNumber({ id: id, phone: phoneNumber });
      const dataObj = {
        id: id,
        email: email,
        paramName: "Phone",
        actionType: "Update",
        paramValue: phoneNumber,
        enterpriseVoiceStatus: enterpriseVoiceStatus,
      };
      const numObj = {
        phoneNumber: phoneNumber,
        allocateStatus: allocateStatus,
      };
      this.setStateAsync({ editedNumber: null });
      this.setStateAsync({ assignedNumber: phoneNumber });
      await this.setUsersChangeRecords(dataObj);
      await this.setNumberChangeRecords(numObj);
      await this.checkUsersData();
    }
  };

  removePhoneNumber = async (
    id,
    email,
    enterpriseVoiceStatus,
    phoneNumber,
    allocateStatus
  ) => {
    if (id !== null && id.length > 0 && email && email.length > 0) {
      await this.props.updateUserPhoneNumber({ id: id, phone: "" });
      const dataObj = {
        id: id,
        email: email,
        paramName: "Phone",
        actionType: "Remove",
        paramValue: null,
        enterpriseVoiceStatus: enterpriseVoiceStatus,
      };
      const numObj = {
        phoneNumber: phoneNumber,
        allocateStatus: allocateStatus,
      };
      this.setStateAsync({ editedNumber: null });
      this.setStateAsync({ removedNumber: phoneNumber });
      await this.setUsersChangeRecords(dataObj);
      await this.setEditNumberChangeRecords(numObj);
      await this.checkUsersData();
    }
  };

  editPhoneNumber = async (phoneNumber, allocateStatus) => {
    const numObj = {
      phoneNumber: phoneNumber,
      allocateStatus: allocateStatus,
    };
    this.setStateAsync({ editedNumber: phoneNumber });
    await this.setEditNumberChangeRecords(numObj);
    await this.checkUsersData();
  };
  cancelPhoneNumber = async (phoneNumber, allocateStatus) => {
    const numObj = {
      phoneNumber: phoneNumber,
      allocateStatus: allocateStatus,
    };
    await this.setEditNumberChangeRecords(numObj);
    await this.checkUsersData();
  };

  updateRoutingPolicy = async (id, email, policyId, enterpriseVoiceStatus) => {
    if (
      id !== null &&
      id.length > 0 &&
      policyId &&
      policyId.length > 0 &&
      email &&
      email.length > 0
    ) {
      await this.props.updateUserRoutingPolicy({
        id: id,
        policyId: policyId,
      });
      const dataObj = {
        id: id,
        email: email,
        paramName: "Policy",
        actionType: "Update",
        paramValue: policyId,
        enterpriseVoiceStatus: enterpriseVoiceStatus,
      };
      await this.setUsersChangeRecords(dataObj);
      await this.checkUsersData();
    }
  };

  removeRoutingPolicy = async (id, email, enterpriseVoiceStatus) => {
    if (id !== null && id.length > 0 && email && email.length > 0) {
      await this.props.updateUserRoutingPolicy({ id: id, policyId: "" });
      const dataObj = {
        id: id,
        email: email,
        paramName: "Policy",
        actionType: "Remove",
        paramValue: null,
        enterpriseVoiceStatus: enterpriseVoiceStatus,
      };
      await this.setUsersChangeRecords(dataObj);
      await this.checkUsersData();
    }
  };

  resetRoutingPolicy = async (id, policyId) => {
    await this.props.updateUserRoutingPolicy({
      id: id,
      policyId: policyId,
    });
    const usersArray = this.state.usersUpdateRecords;
    const dataObj = await usersArray.filter((users) => {
      if (users.id === id && users.paramName === "Policy") {
        return false;
      } else {
        return true;
      }
    });
    await this.setStateAsync({ usersUpdateRecords: dataObj });
    await this.checkUsersData();
  };

  resetPhoneNumber = async (id, phoneNumber) => {
    await this.props.updateUserPhoneNumber({ id: id, phone: phoneNumber });
    const usersArray = this.state.usersUpdateRecords;
    if (usersArray) {
      const dataObj = await usersArray.filter((users) => {
        if (users.id === id && users.paramName === "Phone") {
          return false;
        } else {
          return true;
        }
      });
      await this.setStateAsync({ usersUpdateRecords: dataObj });
      await this.checkUsersData();
    }
  };

  setEditNumberChangeRecords = async (numObj) => {
    if (numObj && this.state.usersNumbersRecords) {
      let numItem = null;
      let numIndex = null;
      await this.state.usersNumbersRecords.forEach((num, index) => {
        if (num.phoneNumber === numObj.phoneNumber) {
          numItem = num;
          numIndex = index;
          return;
        }
      });
      if (numItem) {
        numItem.allocateStatus = numObj.allocateStatus;
        await this.setState((prevState) => {
          const result = [...prevState.usersNumbersRecords];
          result[numIndex] = numItem;
          return { usersNumbersRecords: result };
        });
      } else {
        let data = this.state.usersNumbersRecords;
        data.push(numObj);
        await this.setState({
          usersNumbersRecords: data,
        });
      }
    }
  };

  setNumberChangeRecords = async (numObj) => {
    if (numObj && this.state.usersNumbersRecords) {
      let numItem = null;
      let numIndex = null;
      await this.state.usersNumbersRecords.forEach((num, index) => {
        if (num.phoneNumber === numObj.phoneNumber) {
          numItem = num;
          numIndex = index;
          return;
        }
      });
      if (numItem) {
        numItem.phoneNumber = numObj.phoneNumber;
        numItem.allocateStatus = numObj.allocateStatus;
        await this.setState((prevState) => {
          const result = [...prevState.usersNumbersRecords];
          result[numIndex] = numItem;
          return { usersNumbersRecords: result };
        });
      }
    } else {
      let data = this.state.usersNumbersRecords;
      data.push(numObj);
      await this.setState({
        usersNumbersRecords: data,
      });
    }
  };

  setUsersChangeRecords = async (dataObj) => {
    if (dataObj && this.state.usersUpdateRecords) {
      let userItem = null;
      let userIndex = null;
      await this.state.usersUpdateRecords.forEach((user, index) => {
        if (user.id === dataObj.id && user.paramName === dataObj.paramName) {
          userItem = user;
          userIndex = index;
          return;
        }
      });

      if (userItem) {
        userItem.paramValue = dataObj.paramValue;
        userItem.actionType = dataObj.actionType;
        userItem.enterpriseVoiceStatus = dataObj.enterpriseVoiceStatus;
        await this.setState((prevState) => {
          const result = [...prevState.usersUpdateRecords];
          result[userIndex] = userItem;
          return { usersUpdateRecords: result };
        });
      } else {
        let data = this.state.usersUpdateRecords;
        // data = data.slice(0);
        // data.splice(0, 0, dataObj);
        data.push(dataObj);
        await this.setState({
          usersUpdateRecords: data,
        });
      }
    }
  };

  setUsersCheckboxRecord = async (dataObj) => {
    await this.props.updateUserCheckbox({
      id: dataObj.id,
      isSelected: dataObj.isSelected,
    });
    let isFormDataChecked = this.props.usersAllRecords.some(
      (x) => x.isSelected === true
    );
    await this.setStateAsync({ isFormDataChecked: isFormDataChecked });
    await this.clearAlert();
  };

  resetUsersCheckboxRecord = async () => {
    if (this.props.usersAllRecords && this.props.usersAllRecords.length > 0) {
      let records = this.props.usersAllRecords.map((rec) => ({
        ...rec,
        isSelected: false,
        isPhonePopupOpen:false,
        isPolicyPopupOpen:false
      }));
      await this.props.setUsersAllRecords([...records]);
    }
  };

  updateTenentUsers = async () => {
    await this.clearAlert();
    await this.setStateAsync({
      showPolicyDialog: false,
    });
    if (
      this.state.usersUpdateRecords &&
      this.state.usersUpdateRecords.length > 0
    ) {
      let usersUpdateRecords = _.uniqBy(
        this.state.usersUpdateRecords,
        (data) => data.email
      );
      if (
        usersUpdateRecords &&
        usersUpdateRecords.length <=
          VoiceAdminConstants.USERS.NUMBER_OF_USER_LESS_THAN_ONE_HUNDRED
      ) {
        await this.props.showPageWaitDialog(
          IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.info.pleaseWaitUpdatingData"
          )
        );
        const data = {
          refreshToken: TokenUtil.getIdentitySippioRefreshToken(),
          data: [...this.state.usersUpdateRecords],
        };
        await this.setStateAsync({ usersUpdateRecords: [] });
        PageUtil.scrollIntoView(this.usersPageTableRef);
        await tenentUsersUpdateBulk(data, this._cancelToken)
          .then(async (res) => {
            if (
              res &&
              res.status === AppConfigProps.httpStatusCode.ok &&
              res.data &&
              res.data.result
            ) {
              await this.fetchTenentUsersBulkStatus();
              await this.resetUsersCheckboxRecord();
              await this.fetchSubscriberNumbers();
            } else {
              await this.props.hidePageWaitDialog();
              await this.setStateAsync({
                isFormDataSelected: false,
                isFormDataChecked: false,
              });
              await manageError(new Error(), this.props.history);
            }
          })
          .catch(async (err) => {
            await this.props.hidePageWaitDialog();
            await this.setStateAsync({
              isFormDataSelected: false,
              isFormDataChecked: false,
            });
            const errorStatus = ResponseUtil.getStatus(err);
            if (
              errorStatus &&
              errorStatus === AppConfigProps.httpStatusCode.badRequest
            ) {
              const primeError = ResponseUtil.getPrimeError(err);
              if (
                primeError &&
                primeError.code ===
                  VoiceAdminConstants.SERVER_ERROR_CODE.VOICE_SETUP_NOTCOMPLETED
              ) {
                this.props.history.push(VoiceAdminURLProps.setup);
                return;
              } else if (
                primeError &&
                (primeError.code ===
                  VoiceAdminConstants.SERVER_ERROR_CODE
                    .USERS_DATA_UPDATE_FAILED ||
                  primeError.code ===
                    VoiceAdminConstants.SERVER_ERROR_CODE
                      .USERS_DATA_UPDATE_ALREADY_INPROGRESS)
              ) {
                await this.setStateAsync({
                  errorDetails: primeError.message,
                });
              }
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_users,
                  "notification.error.usersDataUpdateFailed"
                ),
                showAlert: true,
              });
            } else {
              await manageError(err, this.props.history);
            }
          });
        await this.props.hidePageWaitDialog();
        await this.setStateAsync({
          isFormDataSelected: false,
          isFormDataChecked: false,
        });
      } else {
        await this.setStateAsync({
          errorMessage: IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.error.numberOfUsersLessThenOneHundred"
          ),
          showAlert: true,
        });
      }
    }
  };

  phoneNumberSort = (numbers) => {
    if (numbers && numbers.length > 0) {
      let sortedPhoneNumbers = _.sortBy(numbers, (number) => {
        return parseInt(number.phoneNumber);
      });

      if (this.state.editedNumber !== null) {
        let selectedNumber = numbers.find(
          (selectedNumber) =>
            selectedNumber.phoneNumber === this.state.editedNumber
        );
        if (selectedNumber) {
          sortedPhoneNumbers.unshift(selectedNumber); // add edited selected PhoneNumber in beginning of an array list
        }
      }

      return sortedPhoneNumbers;
    }
  };

  removeBulkUserPolicy = async () => {
    if (this.props.usersAllRecords && this.props.usersAllRecords.length > 0) {
      let policyRemove = [];
      this.props.usersAllRecords.filter((user) => {
        if (user.isSelected === true) {
          let policy = {
            id: user.id,
            email: user.email,
            paramName: "Policy",
            actionType: "Remove",
            paramValue: "",
            enterpriseVoiceStatus: user.enterpriseVoiceStatus,
          };
          policyRemove.push(policy);
        }
        return "";
      });
      await this.setStateAsync({ usersUpdateRecords: policyRemove });
      await this.updateTenentUsers();
    }
  };

  updateBulkUsersPolicy = async () => {
    if (
      this.props.usersAllRecords &&
      this.props.usersAllRecords.length > 0 &&
      this.state.selectedPolicy !== ""
    ) {
      let policyUpdate = [];
      this.props.usersAllRecords.filter((user) => {
        if (user.isSelected === true) {
          let policy = {
            id: user.id,
            email: user.email,
            paramName: "Policy",
            actionType: "Update",
            paramValue: this.state.selectedPolicy.trim(),
            enterpriseVoiceStatus: user.enterpriseVoiceStatus,
          };
          policyUpdate.push(policy);
        }
        return null;
      });
      await this.setStateAsync({ usersUpdateRecords: policyUpdate });
      await this.updateTenentUsers();
    }
  };

  renderPopupDropdown = () => {
    if (
      this.props.usersRoutingPolicies &&
      this.props.usersRoutingPolicies.length > 0
    ) {
      let sortedPolicies = _.orderBy(
        this.props.usersRoutingPolicies,
        (policy) => policy.toLowerCase(),
        "asc"
      );
      return (
        <>
          <Flex gap="gap.small">
            <Dropdown
              value={this.state.selectedPolicy}
              items={sortedPolicies}
              className="update-policy-dropdown"
              placeholder={IntlUtil.getText(
                this._intl_ns_vpa_users,
                "content.selectPolicy"
              )}
              onChange={(e, select) => {
                this.handlePolicyUpdate(e, select);
              }}
            />
            <Flex.Item push>
              <Button
                className="vpa-usn-button"
                primary
                disabled={this.state.selectedPolicy === ""}
                content={IntlUtil.getText(
                  this._intl_ns_vpa_users,
                  "content.save"
                )}
                onClick={() => this.updateBulkUsersPolicy()}
              />
            </Flex.Item>
          </Flex>
        </>
      );
    }
  };

  handlePolicyUpdate = async (e, select) => {
    await this.setState({ selectedPolicy: select.value });
  };

  handleShowPolicyDialog = async () => {
    await this.setState({ showPolicyDialog: true });
  };

  handleHidePolicyDialog = async () => {
    await this.setState({ showPolicyDialog: false });
  };

  setUserFilterSearch = async (queryData) => {
    PageUtil.scrollIntoView(this.usersPageTableRef);
    await this.setStateAsync({ usersUpdateRecords: [] });
    await this.fetchTenentSearchUsers(queryData);
    let isFormDataChecked = this.props.usersAllRecords.some(
      (x) => x.isSelected === true
    );
    await this.setStateAsync({ isFormDataChecked: isFormDataChecked });
    await this.checkUsersData();
  };

  fetchTenentSearchUsers = async (queryData) => {
    await this.setStateAsync({ isListDataFetched: true });
    await this.handleFilterCloseDialog();
    await this.clearAlert();
    await axios
      .all([
        getTenentUsers(queryData, this._cancelToken),
        getTenentUsersBulk(this.state.usersBulkStatus, this._cancelToken),
      ])
      .then(
        axios.spread(async (usersData, propagationData) => {
          if (
            usersData &&
            usersData.status === AppConfigProps.httpStatusCode.ok &&
            usersData.data &&
            propagationData &&
            propagationData.status === AppConfigProps.httpStatusCode.ok &&
            propagationData.data
          ) {
            if (propagationData.data.result) {
              const propagation = propagationData.data.result;
              await this.setStateAsync({ usersPropagation: propagation });
              if (
                propagation.overallStatus !==
                VoiceAdminConstants.USN_DATA_PROPAGATION
                  .OVERALL_STATUS_COMPLETED
              ) {
                await this.setStateAsync({ isAlterDataPropagated: false });
              } else {
                await this.setStateAsync({ isAlterDataPropagated: true });
              }
            }
            if (usersData.data.records) {
              let filterInfo = usersData.data.info.filter;
              let records = [];
              records = await usersData.data.records.map((rec) => ({
                ...rec,
                originalPhone: rec.phone,
                originalPolicyId: rec?.policyId,
                isSelected: false,
                isPhonePopupOpen:false,
                isPolicyPopupOpen:false
              }));
              await this.props.setUsersAllRecords([...records]);
              await this.setStateAsync({
                searchCriteria: {
                  ...this.state.searchCriteria,
                  name: filterInfo.name ? filterInfo.name : "",
                  email: filterInfo.email ? filterInfo.email : "",
                  phone: filterInfo.phone ? filterInfo.phone : "",
                  policyId: filterInfo.policyId ? filterInfo.policyId : "",
                  usageLocation:filterInfo?.usageLocation?filterInfo?.usageLocation:"",
                  numberAssignmentStatus:filterInfo?.numberAssignmentStatus?filterInfo?.numberAssignmentStatus:"",
                  filterType: filterInfo.filterType
                    ? filterInfo.filterType
                    : VoiceAdminConstants.USERS.FILTER_CONDITIONS
                        .ANY_CONDITIONS,
                  nextLink: usersData.data.info.nextLink
                    ? usersData.data.info.nextLink
                    : "",
                },
                isPageDataFetched: true,
                isShowTooltip: false,
              });
              await setTimeout(
                () => this.setStateAsync({ isShowTooltip: false }),
                5000
              );
              await this.cleanLocationState();
            }
            await this.setStateAsync({ isListDataFetched: false });
          }
        })
      )
      .catch(async (err) => {
        await this.setStateAsync({ isListDataFetched: false });
        const errorStatus = ResponseUtil.getStatus(err);
        if (
          errorStatus &&
          errorStatus === AppConfigProps.httpStatusCode.badRequest
        ) {
          const primeError = ResponseUtil.getPrimeError(err);
          if (primeError) {
            if (
              primeError.code ===
              VoiceAdminConstants.SERVER_ERROR_CODE.VOICE_SETUP_NOTCOMPLETED
            ) {
              this.props.history.push(VoiceAdminURLProps.setup);
              return;
            } else if (
              primeError.code ===
                VoiceAdminConstants.SERVER_ERROR_CODE
                  .USERS_QUERY_PERAMETER_MISSING_OR_INVALID ||
              primeError.code ===
                VoiceAdminConstants.SERVER_ERROR_CODE.USERS_MICROSOFT_TENANT
            ) {
              await this.setStateAsync({
                errorDetails: primeError.message,
              });
            }
          }

          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_users,
              "notification.error.usersDataRetrievingFailed"
            ),
            showAlert: true,
          });
        } else {
          await manageError(err, this.props.history);
        }
      });
  };

  handleLoadMore = async () => {
    await this.setStateAsync({ isListLoadMore: true });
    let queryData = this.state.searchCriteria;
    await this.fetchTenentLodaMoreUsers(queryData);
    await this.setStateAsync({ isListLoadMore: false });
  };

  fetchTenentLodaMoreUsers = async (queryData) => {
    await this.handleFilterCloseDialog();
    await this.clearAlert();
    await getTenentUsers(queryData, this._cancelToken)
      .then(async (res) => {
        if (
          res &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res.data
        ) {
          let filterInfo = res.data.info.filter;
          let records = [];
          records = await res.data.records.map((rec) => ({
            ...rec,
            originalPhone: rec.phone,
            originalPolicyId: rec?.policyId,
            isSelected: false,
            isPhonePopupOpen:false,
            isPolicyPopupOpen:false
          }));
          let userRecord = [...this.props.usersAllRecords, ...records];
          await this.props.setUsersAllRecords(userRecord);
          await this.setStateAsync({
            searchCriteria: {
              ...this.state.searchCriteria,
              name: filterInfo.name ? filterInfo.name : "",
              email: filterInfo.email ? filterInfo.email : "",
              phone: filterInfo.phone ? filterInfo.phone : "",
              policyId: filterInfo.policyId ? filterInfo.policyId : "",
              usageLocation:filterInfo?.usageLocation?filterInfo?.usageLocation:"",
              numberAssignmentStatus:filterInfo?.numberAssignmentStatus?filterInfo?.numberAssignmentStatus:"",
              filterType: filterInfo.filterType
                ? filterInfo.filterType
                : VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
              nextLink: res.data.info.nextLink ? res.data.info.nextLink : "",
            },
            isPageDataFetched: true,
          });
        }
      })
      .catch(async (err) => {
        await this.setStateAsync({ isPageDataFetched: true });
        const errorStatus = ResponseUtil.getStatus(err);
        if (
          errorStatus &&
          errorStatus === AppConfigProps.httpStatusCode.badRequest
        ) {
          const primeError = ResponseUtil.getPrimeError(err);
          if (
            primeError &&
            primeError.code ===
              VoiceAdminConstants.SERVER_ERROR_CODE.VOICE_SETUP_NOTCOMPLETED
          ) {
            this.props.history.push(VoiceAdminURLProps.setup);
            return;
          } else if (
            primeError &&
            (primeError.code ===
              VoiceAdminConstants.SERVER_ERROR_CODE
                .USERS_QUERY_PERAMETER_MISSING_OR_INVALID ||
              primeError.code ===
                VoiceAdminConstants.SERVER_ERROR_CODE.USERS_MICROSOFT_TENANT)
          ) {
            await this.setStateAsync({
              errorDetails: primeError.message,
            });
          }

          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_users,
              "notification.error.usersDataRetrievingFailed"
            ),
            showAlert: true,
          });
        } else {
          await manageError(err, this.props.history);
        }
      });
  };

  renderDisplayingRecord = () => {
    if (this.props.usersAllRecords && this.props.usersAllRecords.length > 0) {
      let pageSize = 0;
      let start = pageSize * this.props.usersAllRecords.length;
      let end = start + this.props.usersAllRecords.length;

      return (
        <Flex wrap gap="gap.smaller" vAlign="center">
          <Text className="page-title-text">
            {IntlUtil.getText(this._intl_ns_vpa_users, "content.users")}
          </Text>
          <Text className="page-text text-fc-dark m-t-5 p-l-5">
            {IntlUtil.getSubstituteText(
              this._intl_ns_vpa_users,
              "content.displaying",
              [
                {
                  key: "<START>",
                  value: start + 1,
                },
                {
                  key: "<END>",
                  value: end,
                },
              ]
            )}
          </Text>
          {this.state.searchCriteria.nextLink !== "" ? (
            <Tooltip
              onOpenChange={(e, data) =>
                this.setStateAsync({ isShowTooltip: data.open })
              }
              open={this.state.isShowTooltip}
              trigger={<ExclamationCircleIcon className="m-t-5" />}
              content={
                <Text>
                  {IntlUtil.getText(
                    this._intl_ns_vpa_users,
                    "notification.info.displayingTooltip"
                  )}
                </Text>
              }
              align="center"
              position="below"
            />
          ) : null}
        </Flex>
      );
    } else {
      return (
        <Flex wrap gap="gap.smaller" vAlign="center">
          <Text className="page-title-text">
            {IntlUtil.getText(this._intl_ns_vpa_users, "content.users")}
          </Text>

          {this.state.searchCriteria.nextLink !== "" ? (
            <>
              <Text className="page-text text-fc-black m-t-5 p-l-5">
                {IntlUtil.getText(
                  this._intl_ns_vpa_users,
                  "content.usersFound"
                )}
              </Text>
              <Tooltip
                onOpenChange={(e, data) =>
                  this.setStateAsync({ isShowTooltip: data.open })
                }
                open={this.state.isShowTooltip}
                trigger={<ExclamationCircleIcon className="m-t-5" />}
                content={
                  <Text>
                    {IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.tooltip.viewUsers"
                    )}
                  </Text>
                }
                align="center"
                position="below"
              />
            </>
          ) : (
            <Text className="page-text text-fc-black m-t-5 p-l-5">
              {IntlUtil.getText(
                this._intl_ns_vpa_users,
                "content.noUsersFound"
              )}
            </Text>
          )}
        </Flex>
      );
    }
  };

  showImportUsers = async () => {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await this.setState({ showImportDialog: true });
    } else {
      this.props.history.push(AppURLProps.signin);
    }
  };

  showExportUsers = async () => {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await this.setState({ showExportDialog: true });
    } else {
      this.props.history.push(AppURLProps.signin);
    }
  };

  renderImportDialog = () => {
    return (
      <UsersImport
        showDialogBox={this.state.showImportDialog}
        hideDialogBox={() => this.setState({ showImportDialog: false })}
        fetchUsersData={async () => {
          await this.fetchTenentUsersBulkStatus();
        }}
      />
    );
  };

  renderExportDialog = () => {
    return (
      <Dialog
        backdrop={true}
        confirmButton={IntlUtil.getText(this._intl_ns_vpa_common, "content.ok")}
        onConfirm={() => {
          this.setState({
            showExportDialog: false,
          });
        }}
        open={this.state.showExportDialog}
        content={
          <Text
            className="vpa-page-dialog-info-text"
            content={IntlUtil.getText(
              this._intl_ns_vpa_users,
              "notification.info.exportUnavailableInfo"
            )}
          />
        }
        className="vpa-page-dialog"
      />
    );
  };

  renderFilterDialog = () => {
    return (
      <UserFilter
        open={this.state.isFilterOpenDialog}
        searchCriteria={this.state.searchCriteria}
        setFilterSearch={this.setUserFilterSearch}
        hideDialogBox={() => {
          this.setState({ isFilterOpenDialog: false });
        }}
        countryStatesData={this.props.countryStatesData}
        usersRoutingPoliciesList={this.props.usersRoutingPolicies}
      />
    );
  };

  renderNumbersSyncDialog = () => {
    if (this.state.showSyncDialog)
      return (
        <NumbersSyncDialog
          showSyncDialog={this.state.showSyncDialog}
          syncResponse={this.state.syncTenantAccountRecords}
          numberRemoved={this.state.numberRemoved}
          numbersSyncCompleted={this.numbersSyncCompleted}
          closeNumberSyncDialog={this.closeNumberSyncDialog}
          syncResponseUpdate={this.syncResponseUpdate}
          resetNumberRemoval={async () =>
            await this.setStateAsync({ numberRemoved: false })
          }
          dataUpdateInProgress={!this.state.isAlterDataPropagated}
          dataUpdateMessage={IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.info.usersDataUpdateInProgress"
          )}
          dataUpdateMessageTwo={IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.info.usersDataUpdateInProgressTwo"
          )}
          numberRemovalMessage={IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.info.numberRemovalMessage"
          )}
          syncNumbersInProgressUpdate={this.syncNumbersInProgressUpdate}
        />
      );
  };

  syncNumbersInProgressUpdate = async (isInProgress) => {
    await this.setStateAsync({ syncNumbersInProgress: isInProgress });
  };

  syncResponseUpdate = async (syncResponse) => {
    await this.setStateAsync({ syncTenantAccountRecords: syncResponse });
  };

  closeNumberSyncDialog = async () => {
    await this.setStateAsync({ showSyncDialog: false });
    if (this.state.numberRemoved) {
      await this.setStateAsync({ numberRemoved: false });
    }
  };

  numbersSyncCompleted = async () => {
    await this.fetchSubscriberNumbers();
  };
  renderLoadMore = () => {
    return (
      <>
        {" "}
        {this.state.searchCriteria.nextLink !== "" ? (
          <Flex vAlign="center" className="vpa-usn-load-more">
            <Button
              fluid
              loading={this.state.isListLoadMore}
              onClick={() => this.handleLoadMore()}
              size="small"
              className="vpa-usn-load-more-button"
              content={
                this.state.isListLoadMore ? (
                  <Text className="text-fc-primary">Loading</Text>
                ) : (
                  <Text className="text-fc-primary p-r-7">Load More</Text>
                )
              }
            />
          </Flex>
        ) : null}
      </>
    );
  };

  handleScrollChange=async()=>{
    let userRecords=[];
    if (this.props.usersAllRecords?.length > 0) {
          this.props.usersAllRecords.forEach((usr) => {
            
              usr.isPhonePopupOpen = false;
              usr.isPolicyPopupOpen=false;
            
            userRecords.push({ ...usr });
          });
          await this.props.setUsersAllRecords(userRecords);
        
  }
}
  render() {
    return (
      <>
        <AppPageTitle
          pageTitle={IntlUtil.getText(
            this._intl_ns_vpa_users,
            "title.usersList"
          )}
        />
        <Flex column className="page-wrapper">
          <Flex column className="vpa-usn-page-content p-b-0">
            <PageLoader
              status={this.state.isPageDataFetched}
              size="medium"
              labelPosition="below"
              label={IntlUtil.getText(
                this._intl_ns_common,
                "content.loadingInprogress"
              )}
              type="full-center"
            >
              <Grid fluid className="page-grid p-t-10">
                <Row>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={3}
                    xl={3}
                    className="m-m-b-10"
                  >
                    {this.renderDisplayingRecord()}
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                    {this.state.showAlert === false ? (
                      <div>
                        {this.state.usersPropagation ? (
                          <>
                            {this.state.isAlterDataPropagated === false ? (
                              <Row>
                                <Col xs={12}>
                                  <AlertInfoMessage
                                    fitted={true}
                                    content={IntlUtil.getText(
                                      this._intl_ns_vpa_users,
                                      "notification.info.usersDataPropagationInprogress"
                                    )}
                                    linkDetails={{
                                      label: IntlUtil.getText(
                                        this._intl_ns_vpa_users,
                                        "content.viewStatus"
                                      ),
                                      callback: this.openUsersStatusDialog,
                                    }}
                                  />
                                </Col>
                              </Row>
                            ) : this.state.syncNumbersInProgress ? (
                              <Row>
                                <Col xs={12}>
                                  <AlertInfoMessage
                                    fitted={true}
                                    content={IntlUtil.getText(
                                      this._intl_ns_vpa_users,
                                      "notification.info.syncNumbersInProgress"
                                    )}
                                    linkDetails={{
                                      label: IntlUtil.getText(
                                        this._intl_ns_vpa_users,
                                        "content.viewStatus"
                                      ),
                                      callback: async () =>
                                        await this.setStateAsync({
                                          showSyncDialog: true,
                                        }),
                                    }}
                                  />
                                </Col>
                              </Row>
                            ) : (
                              <Row>
                                <Col xs={12} lg={11} md={11}>
                                  <AlertInfoMessage
                                    fitted={true}
                                    content={this.getUsersPropagationInfoText(
                                      this.state.usersPropagation
                                    )}
                                    linkDetails={{
                                      label: IntlUtil.getText(
                                        this._intl_ns_vpa_users,
                                        "content.viewResult"
                                      ),
                                      callback: this.openUsersStatusDialog,
                                    }}
                                  />
                                </Col>
                              </Row>
                            )}
                          </>
                        ) : this.state.syncNumbersInProgress ? (
                          <Row>
                            <Col xs={12}>
                              <AlertInfoMessage
                                fitted={true}
                                content={IntlUtil.getText(
                                  this._intl_ns_vpa_users,
                                  "notification.info.syncNumbersInProgress"
                                )}
                                linkDetails={{
                                  label: IntlUtil.getText(
                                    this._intl_ns_vpa_users,
                                    "content.viewStatus"
                                  ),
                                  callback: async () =>
                                    await this.setStateAsync({
                                      showSyncDialog: true,
                                    }),
                                }}
                              />
                            </Col>
                          </Row>
                        ) : null}
                      </div>
                    ) : null}
                    {this.state.showAlert === true ? (
                      <Row>
                        <Col xs={12} lg={9}>
                          {this.state.errorMessage ? (
                            <AlertErrorMessage
                              content={this.state.errorMessage}
                              moreDetails={{
                                label: IntlUtil.getText(
                                  this._intl_ns_vpa_users,
                                  "content.moreDetails"
                                ),
                                content: this.state.errorDetails,
                              }}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    ) : null}
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={4} xl={3}>
                    {/* <Col xs={12} sm={12} lg={11} md={12} xl={11}> */}
                    <Row start="xs lg" end="xl" className="m-r-5">
                      <Tooltip
                        onOpenChange={(e, data) =>
                          this.setStateAsync({
                            isShowSyncNumbersTooltip: data.open,
                          })
                        }
                        open={this.state.isShowSyncNumbersTooltip}
                        trigger={
                          <Button
                            content={IntlUtil.getText(
                              this._intl_ns_vpa_users,
                              "content.syncNumbers"
                            )}
                            icon={<RetryIcon />}
                            onClick={async () =>
                              await this.setStateAsync({ showSyncDialog: true })
                            }
                            text
                            primary
                          />
                        }
                        content={
                          <Text>
                            {IntlUtil.getText(
                              this._intl_ns_vpa_common,
                              "content.tooltip.numbersSync"
                            )}
                          </Text>
                        }
                        align="center"
                        position="below"
                      />
                      <Button
                        onClick={() => this.handleFilterOpenDialog()}
                        className={classNames("p-r-0", {
                          border: !_.values(
                            _.omit(this.state.searchCriteria, [
                              "nextLink",
                              "filterType",
                              "pageSize",
                            ])
                          ).every(_.isEmpty),
                        })}
                        text
                        primary
                        content={
                          <Text className="page-text text-fs-m text-fc-primary">
                            {IntlUtil.getText(
                              this._intl_ns_vpa_users,
                              "content.filterUsers"
                            )}
                          </Text>
                        }
                        icon={<FilterIcon />}
                      ></Button>
                    </Row>
                    {/* </Col> */}
                  </Col>
                </Row>
                <Row>
                  <Col  xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div column onScroll={this.handleScrollChange} className="vpa-usn-table-wrapper m-t-10">
                      <Table aria-label="table">
                        <div ref={this.usersPageTableRef}>
                          <Flex column className="vpa-usn-table-header-wrapper">
                            <TableRow
                              header
                              className="vpa-usn-table-header-row"
                            >
                              {UsersTenentTableHeaderColumns(
                                this._intl_ns_vpa_users
                              ).map((column) => {
                                return (
                                  <TableHeaderColumn
                                    {...column}
                                    key={column.columnId}
                                  />
                                );
                              })}
                            </TableRow>
                          </Flex>
                          {this.props.usersAllRecords &&
                          this.props.usersAllRecords.length > 0 ? (
                            <>
                              <Flex
                                column
                                className="vpa-usn-table-data-wrapper"
                              >
                                {this.props.usersAllRecords.map(
                                  (user, index) => {
                                    return (
                                      <UserRow
                                        user={user}
                                        key={`user-${index}`}
                                        updatePhoneNumber={
                                          this.updatePhoneNumber
                                        }
                                        totalNumbers={this.state.totalNumbers}
                                        removePhoneNumber={
                                          this.removePhoneNumber
                                        }
                                        resetPhoneNumber={this.resetPhoneNumber}
                                        editPhoneNumber={this.editPhoneNumber}
                                        cancelPhoneNumber={
                                          this.cancelPhoneNumber
                                        }
                                        updateRoutingPolicy={
                                          this.updateRoutingPolicy
                                        }
                                        removeRoutingPolicy={
                                          this.removeRoutingPolicy
                                        }
                                        resetRoutingPolicy={
                                          this.resetRoutingPolicy
                                        }
                                        isAlterDataPropagated={
                                          this.state.isAlterDataPropagated
                                        }
                                        intlNamespace={this._intl_ns_vpa_users}
                                        usersPhoneNumbers={this.phoneNumberSort(
                                          this.state.usersNumbersRecords
                                        )}
                                        history={this.props.history}
                                        editedNumber={this.state.editedNumber}
                                        userCheckBoxSelect={
                                          this.setUsersCheckboxRecord
                                        }
                                        isCheckBoxDisable={
                                          this.state.isFormDataSelected
                                        }
                                        syncNumbersInProgress={
                                          this.state.syncNumbersInProgress
                                        }
                                      />
                                    );
                                  }
                                )}
                                {this.renderLoadMore()}
                              </Flex>
                            </>
                          ) : (
                            <> {this.renderLoadMore()}</>
                          )}
                        </div>
                      </Table>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="m-t-20 p-l-0 p-r-0">
                    <Button
                      primary
                      content={IntlUtil.getText(
                        this._intl_ns_vpa_users,
                        "content.applyChanges"
                      )}
                      onClick={this.updateTenentUsers}
                      disabled={
                        !this.state.isFormDataSelected ||
                        !this.state.isAlterDataPropagated ||
                        this.state.syncNumbersInProgress
                      }
                      className="vpa-usn-button"
                    />
                    <Button
                      disabled={
                        this.state.isFormDataSelected ||
                        !this.state.isAlterDataPropagated ||
                        this.state.isFormDataChecked ||
                        this.props.usersAllRecords.length === 0 ||
                        this.state.syncNumbersInProgress
                      }
                      content={IntlUtil.getText(
                        this._intl_ns_vpa_users,
                        "content.importUsers"
                      )}
                      onClick={() => this.showImportUsers()}
                      primary
                      className="vpa-usn-button"
                    ></Button>
                    <Button
                      disabled={
                        this.state.isFormDataSelected ||
                        !this.state.isAlterDataPropagated ||
                        this.state.isFormDataChecked ||
                        this.props.usersAllRecords.length === 0 ||
                        this.state.syncNumbersInProgress
                      }
                      content={IntlUtil.getText(
                        this._intl_ns_vpa_users,
                        "content.exportUsers"
                      )}
                      onClick={() => this.showExportUsers()}
                      primary
                      className="vpa-usn-button"
                    ></Button>
                    {this.state.isFormDataChecked &&
                    this.props.usersAllRecords.length > 0 ? (
                      <>
                        <Button
                          content={IntlUtil.getText(
                            this._intl_ns_vpa_users,
                            "content.removePolicy"
                          )}
                          disabled={
                            !this.state.isAlterDataPropagated ||
                            this.state.syncNumbersInProgress
                          }
                          onClick={() => this.handleShowPolicyDialog()}
                          primary
                          className="vpa-usn-button"
                        />
                        <Dialog
                          backdrop={true}
                          cancelButton={IntlUtil.getText(
                            this._intl_ns_vpa_users,
                            "content.no"
                          )}
                          confirmButton={IntlUtil.getText(
                            this._intl_ns_vpa_users,
                            "content.yes"
                          )}
                          onConfirm={() => {
                            this.removeBulkUserPolicy();
                          }}
                          onCancel={() => {
                            this.handleHidePolicyDialog();
                          }}
                          open={this.state.showPolicyDialog}
                          content={
                            <Text
                              className="vpa-page-dialog-info-text"
                              content={IntlUtil.getText(
                                this._intl_ns_vpa_users,
                                "content.deletepolicyText"
                              )}
                            />
                          }
                          className="vpa-page-dialog"
                        />
                        <Popup
                          pointing
                          content={this.renderPopupDropdown()}
                          trigger={
                            <Button
                              onClick={() =>
                                this.setState({ selectedPolicy: "" })
                              }
                              content={IntlUtil.getText(
                                this._intl_ns_vpa_users,
                                "content.updatePolicy"
                              )}
                              disabled={
                                !this.state.isAlterDataPropagated ||
                                this.state.syncNumbersInProgress
                              }
                              primary
                              className="vpa-usn-button"
                            />
                          }
                        />
                      </>
                    ) : null}
                  </Col>
                </Row>
              </Grid>
              {this.renderFilterDialog()}
              {this.renderImportDialog()}
              {this.renderExportDialog()}
              {this.renderUsersStatusDialog()}
              {this.renderNumbersSyncDialog()}
              <PageOverlay
                hidden={this.state.isListDataFetched}
                loading={!this.state.isListDataFetched}
              />
            </PageLoader>
          </Flex>
        </Flex>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  usersAllRecords: state.userStore.usersAllRecords,
  usersRoutingPolicies: state.userStore.usersRoutingPolicies,
  countryStatesData: state.generalStore.countryStatesData,

});

const mapActionToProps = {
  resetUsersData,
  setUsersAllRecords,
  showPageWaitDialog,
  hidePageWaitDialog,
  updateUserPhoneNumber,
  updateUserRoutingPolicy,
  updateUserCheckbox,
  getUsersRoutingPolicies,
  setUsersUpdateRecord,
  setUserPhoneNumberToAlter,
  setUserRoutingPolicyToAlter,
};

export default connect(mapStateToProps, mapActionToProps)(usersTenant);
